import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, useHistory, useLocation } from 'react-router-dom';
import {
  DASHBOARD_BILL_VIEW,
  DASHBOARD_IRD_VIEW,
  DASHBOARD_SPA_VIEW,
  FNB_BILL,
  FNB_ORDERS,
  IN_ROOM_DINING,
  SPA,
  HOUSEKEEPING,
  HOUSEKEEPING_VIEW,
  DASHBOARD_REST_VIEW,
  TABLE_RESERVATION,
  DASHBOARD_REST_RESERV_VIEW,
  REST_RESERVATION_CREATE,
  REST_RESERVATION_VIEW,
} from '../constants/DashboardConst';
import {
  RBAC_TYPE_BRANDS,
  RBAC_TYPE_CMS_FEEDBACK,
  RBAC_TYPE_CMS_OFFERS,
  RBAC_TYPE_CMS_TVCHANNELS,
  RBAC_TYPE_DESIGN_CONFIGS,
  RBAC_TYPE_DEVICE_MONITORING,
  RBAC_TYPE_EMAIL_SERVICES,
  RBAC_TYPE_GROUPS,
  RBAC_TYPE_HOTELS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
  RBAC_TYPE_HOTEL_AMENITIES,
  RBAC_TYPE_HOTEL_LOCATION,
  RBAC_TYPE_HOTEL_RESTAURANT,
  RBAC_TYPE_HOTEL_SPA,
  RBAC_TYPE_HOTEL_SYSTEMS,
  RBAC_TYPE_NOTIFICATIONS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
  RBAC_TYPE_SERVICES_SERVICE_REQUEST,
  RBAC_TYPE_SERVICES_TELEPHONY,
  RBAC_TYPE_TEAMS,
  RBAC_TYPE_USERS,
  RBAC_TYPE_VENDOR_CONFIGS,
  RBAC_TYPE_ANALYTICS,
  RBAC_TYPE_CHAT,
  RBAC_TYPE_CMS_ACTIVITYCALENDAR,
  RBAC_TYPE_APP_CONFIGURATIONS,
  RBAC_TYPE_STATISTICS,
  RBAC_TYPE_ENTERTAINMENT,
  RBAC_TYPE_GRMS,
} from '../constants/RoleConsts';
import PrivateRoute from '../routes/PrivateRoute';
import CustomSnackbar from '../shared/custom-snackbar/Custom-Snackbar';
import { checkAuthState } from '../utils/APIUtils';
import { notificationManager } from '../utils/NotificationUtils';
import { getAccessControl } from '../utils/RBACUtil';
import EmailServices from './campaign/email-services/EmailServices';
import GuestInformation from './campaign/guest-information/GuestInformation';
import Notifications from './campaign/notifications/Notifications';
import CityGuide from './cms/city-guide/CityGuide';
import FeedbackPage from './cms/feedback/Feedback';
import Offers from './cms/offers/Offers';
import TvChannels from './cms/tv-channels/TvChannels';
import Devices from './configurations/devices/Devices';
import HotelSystems from './configurations/hotelSystems/HotelSystems';
import Entertainment from './configurations/hotelSystems/moduleSummary/entertainment/Entertainment';
import GuestRoomExperience from './configurations/hotelSystems/moduleSummary/guest-room-experience/Guest-Room-Experience';
import HotelService from './configurations/hotelSystems/moduleSummary/hotel-service/HotelService';
import IntegrationDetails from './configurations/integrations/IntegrationDetails';
import Integrations from './configurations/integrations/Integrations';
import VendorConfigs from './configurations/vendor-configs/VendorConfigs';
import {
  dashboardIRDNotificationSelector,
  dashboardNewOrderSelector,
  fetchFnBDashboardBillSubscription,
  fetchFnBDashboardOrderSubscription,
  fetchIRDDashboardOrderSubscription,
  fetchSpaDashboardOrderSubscription,
  setDashboardViewState,
  setNotification,
  fetchHousekeepingOrderSubscription,
  fetchRestaurantTableDashboardSubscription,
  dashboardFnbIrdModeSelector,
} from './home/DashboardSlice';
import Home from './home/Home';
import Accomodations from './hotel/accomodations/Accomodations';
import Amenities from './hotel/amenities/Amenities';
import Location from './hotel/location/Location';
import Restaurant from './hotel/restaurant/Restaurant';
import Spa from './hotel/spa/Spa';
import Properties from './property/Properties';
import {
  dashboardSelectedRestaurantSelector,
  dashboardSelectedSpaSelector,
  selectedHotelSelector,
} from './property/propertySlice';
import InRoomDining from './services/in-room-dining/In-Room-Dining';
import ServiceRequest from './services/service-request/ServiceRequest';
import Telephony from './services/telephony/Telephony';
import UiBuilderMobile from './ui-builder/Ui-Builder-Mobile';
import UsersAndTeams from './users-and-teams/Users-and-Teams';
import Analytics from './analytics/Analytics';
import Chat from './chat/Chat';
import ActivityCalendar from './cms/activity-calendar/Activity-Calendar';
import AppConfiguration from './configurations/app/AppConfiguration';
import { encryptLocalStorage } from '../utils/authUtils';
import Messages from './campaign/welcome-message/Messages';
// import MFASetup from './settings/mfa-setup/MFA-Setup';
import MFAGuard from '../routes/MFAGuard';

export default function RenderPrivateRoutes(props) {
  const { setLoading = () => {} } = props;
  const [userRolePermissions, setUserRolePermissions] = useState(null);
  const [user, setUser] = useState(null);
  const notification = useSelector(dashboardIRDNotificationSelector);
  const selectedHotel = useSelector(selectedHotelSelector);
  const selectedRestaurant = useSelector(dashboardSelectedRestaurantSelector);
  const selectedSpa = useSelector(dashboardSelectedSpaSelector);
  const dashboardNewOrder = useSelector(dashboardNewOrderSelector);
  const irdMode = useSelector(dashboardFnbIrdModeSelector);
  const handleActiveTabRef = useRef(null);

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userRolePermissions) {
      (async () => {
        try {
          const perms = await getAccessControl();
          setUserRolePermissions(perms);
        } catch (e) {
          console.error('User role retrieval failed');
        }
      })();
    }
  }, [userRolePermissions]);

  useEffect(() => {
    (async () => {
      const currUser = await checkAuthState();
      setUser(currUser);
    })();
  }, []);

  useEffect(() => {
    if (selectedHotel && user?.attributes['custom:role'] !== 'SUPER_ADMIN') {
      encryptLocalStorage('hotelId', selectedHotel);
      dispatch(fetchHousekeepingOrderSubscription(selectedHotel, notification));
    }
  }, [selectedHotel]);

  useEffect(() => {
    if (selectedHotel && irdMode && user?.attributes['custom:role'] !== 'SUPER_ADMIN') {
      encryptLocalStorage('restaurantId', '');
      dispatch(fetchIRDDashboardOrderSubscription(selectedHotel, notification));
    }
  }, [selectedHotel, irdMode]);

  useEffect(() => {
    if (selectedHotel && selectedSpa && user?.attributes['custom:role'] !== 'SUPER_ADMIN') {
      encryptLocalStorage('spaId', selectedSpa.id);
      dispatch(fetchSpaDashboardOrderSubscription(selectedHotel, selectedSpa.id, notification));
    }
  }, [selectedHotel, selectedSpa]);

  useEffect(() => {
    if (
      selectedRestaurant &&
      selectedHotel &&
      !irdMode &&
      user?.attributes['custom:role'] !== 'SUPER_ADMIN'
    ) {
      encryptLocalStorage('restaurantId', selectedRestaurant.id);
      dispatch(
        fetchFnBDashboardOrderSubscription(selectedHotel, selectedRestaurant.id, notification),
      );
      dispatch(
        fetchFnBDashboardBillSubscription(selectedHotel, selectedRestaurant.id, notification),
      );
      dispatch(
        fetchRestaurantTableDashboardSubscription(
          selectedHotel,
          selectedRestaurant.id,
          notification,
        ),
      );
    }
  }, [selectedRestaurant, selectedHotel, irdMode]);

  const onCloseNotification = (notificationIndex) => {
    const currNotification = [...notification];
    currNotification.splice(notificationIndex, 1);
    dispatch(setNotification(currNotification));
  };

  const onClickViewNotification = (notification, notificationIndex) => {
    getDashboardTypeAndObj(notification);
    onCloseNotification(notificationIndex);
  };

  const getDashboardTypeAndObj = (notification) => {
    try {
      let tempNotification = Object.assign({}, notification);
      let type = null;
      let obj = dashboardNewOrder;

      switch (tempNotification?.type) {
        case IN_ROOM_DINING:
          tempNotification['type'] = FNB_ORDERS;
          type = DASHBOARD_IRD_VIEW;
          break;
        case SPA:
          type = DASHBOARD_SPA_VIEW;
          break;
        case FNB_ORDERS:
          type = DASHBOARD_IRD_VIEW;
          break;
        case FNB_BILL:
          tempNotification['type'] = FNB_ORDERS;
          type = DASHBOARD_BILL_VIEW;
          break;
        case TABLE_RESERVATION:
          type = DASHBOARD_REST_VIEW;
          break;
        case HOUSEKEEPING:
          type = HOUSEKEEPING_VIEW;
          break;
        default:
          break;
      }

      if (window?.location?.pathname !== '/') {
        history.push('/');
      }

      // After navigating, it has to run, which is why I added setTimeout with 0 mm.
      setTimeout(() => {
        handleActiveTabRef?.current(null, tempNotification?.type);
        dispatch(setDashboardViewState({ type, status: true, obj }));
      }, 0);
    } catch (exception) {
      notificationManager('error', 'Error getting when pushing notification.');
    }
  };

  return (
    <>
      {user && userRolePermissions && (
        <MFAGuard>
          <Switch>
            {/* MFA Setup route - always accessible */}
            {/* <PrivateRoute
              path='/mfa-setup'
              component={MFASetup}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={['home']}
              user={user}
            /> */}
            <PrivateRoute
              path='/properties'
              component={Properties}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_GROUPS, RBAC_TYPE_BRANDS, RBAC_TYPE_HOTELS]}
              user={user}
            />
            <PrivateRoute
              path='/accommodations'
              component={Accomodations}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_HOTEL_ACCOMMODATIONS]}
              user={user}
            />
            <PrivateRoute
              path='/location'
              component={Location}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_HOTEL_LOCATION]}
              user={user}
            />
            <PrivateRoute
              path='/amenities'
              component={Amenities}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_HOTEL_AMENITIES]}
              user={user}
            />
            <PrivateRoute
              path='/hotel-systems'
              component={HotelSystems}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_HOTEL_SYSTEMS]}
              user={user}
            />
            <PrivateRoute
              path='/hotel-service'
              component={HotelService}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_HOTEL_SYSTEMS]}
              user={user}
            />
            <PrivateRoute
              path='/app-configuration'
              component={AppConfiguration}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_APP_CONFIGURATIONS]}
              user={user}
            />
            <PrivateRoute
              path='/entertainment'
              component={Entertainment}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_ENTERTAINMENT]}
              user={user}
            />
            <PrivateRoute
              path='/guest-room-experience'
              component={GuestRoomExperience}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_GRMS]}
              user={user}
            />
            <PrivateRoute
              path='/vendor-config'
              component={VendorConfigs}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_VENDOR_CONFIGS]}
              user={user}
            />
            <PrivateRoute
              path='/integrations'
              component={Integrations}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_VENDOR_CONFIGS]}
              user={user}
            />
            <PrivateRoute
              path='/devices'
              component={Devices}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_DEVICE_MONITORING]}
              user={user}
            />
            <PrivateRoute
              path='/users-and-teams'
              component={UsersAndTeams}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_USERS, RBAC_TYPE_TEAMS]}
              user={user}
            />
            <PrivateRoute
              path='/analytics'
              component={Analytics}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_ANALYTICS]}
              user={user}
            />
            <PrivateRoute
              path='/restaurant'
              component={Restaurant}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_HOTEL_RESTAURANT]}
              user={user}
            />
            <PrivateRoute
              path='/in-room-dining'
              component={InRoomDining}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_SERVICES_IN_ROOM_DINING]}
              user={user}
            />
            <PrivateRoute
              path='/ui-builder'
              component={UiBuilderMobile}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_DESIGN_CONFIGS]}
              user={user}
            />
            <PrivateRoute
              path='/service-request'
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_SERVICES_SERVICE_REQUEST]}
              component={ServiceRequest}
              user={user}
            />
            <PrivateRoute
              path='/telephony'
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_SERVICES_TELEPHONY]}
              component={Telephony}
              user={user}
            />
            <PrivateRoute
              path='/spa'
              component={Spa}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_HOTEL_SPA]}
              user={user}
            />
            <PrivateRoute
              path='/offers'
              component={Offers}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_CMS_OFFERS]}
              user={user}
            />
            <PrivateRoute
              path='/activities'
              component={ActivityCalendar}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_CMS_ACTIVITYCALENDAR]}
              user={user}
            />
            <PrivateRoute
              path='/city-guide'
              component={CityGuide}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_CMS_OFFERS]}
              user={user}
            />
            <PrivateRoute
              path='/feedback-cms'
              component={FeedbackPage}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_CMS_FEEDBACK]}
              user={user}
            />
            <PrivateRoute
              path='/tvchannels'
              component={TvChannels}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_CMS_TVCHANNELS]}
              user={user}
            />
            <PrivateRoute
              path='/notifications'
              component={Notifications}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_NOTIFICATIONS]}
              user={user}
            />
            <PrivateRoute
              path='/email-services'
              component={EmailServices}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_EMAIL_SERVICES]}
              user={user}
            />
            <PrivateRoute
              path='/guest-information'
              component={GuestInformation}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_NOTIFICATIONS]}
              user={user}
            />
            <PrivateRoute
              path='/welcome-message'
              component={Messages}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_NOTIFICATIONS]}
              user={user}
            />
            <PrivateRoute
              path='/integration-details'
              component={IntegrationDetails}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={['home']}
              user={user}
            />
            <PrivateRoute
              path='/chat'
              component={Chat}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={[RBAC_TYPE_CHAT]}
              user={user}
            />
            <PrivateRoute
              path='/'
              component={Home}
              loading={setLoading}
              permissions={userRolePermissions}
              accessTypes={['home']}
              user={user}
              location={location}
              handleActiveTabRef={handleActiveTabRef}
            />
          </Switch>
        </MFAGuard>
      )}
      {notification?.map((notificationData, notificationNdx) => (
        <div key={notificationNdx}>
          <CustomSnackbar
            notification={notificationData}
            onCloseNotification={onCloseNotification}
            onClickViewNotification={onClickViewNotification}
            notificationNdx={notificationNdx}
          />
        </div>
      ))}
    </>
  );
}
